(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-product-details')) {
    customElements.define('sc-product-details', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section');
        this.onVariant = event => {
          const id = event.detail?.variant?.id;
          const template = this.querySelector(`template[data-sc-variant="${id}"]`);
          if (!template) return;
          this.querySelector('[data-sc-details-content]').replaceChildren(template.content.cloneNode(true));
          if (this.querySelector('details').open) this.querySelector('[data-collapsible-body]').style.height = 'auto';
        };
        this.scope?.addEventListener('theme:variant:change', this.onVariant);
      }
      disconnectedCallback() { this.scope?.removeEventListener('theme:variant:change', this.onVariant); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
